import { IAnswer } from "../Interfaces";

export class Answer {

    tribe:string;
    id: string;
    lastName: string;
    firstName: string;
    fullName: string;
    email: string;
    domain: string;
    majorComp: string;
    detailComp: string;
    value: string;
    date: Date = new Date();

    constructor(_tribe:string,_id: string, _lastName: string, _firstName: string, _fullName: string, _email: string, _domain: string, _majorComp: string, _detailComp: string, _value: string) {
        this.tribe =_tribe;
        this.id = _id;
        this.lastName = _lastName;
        this.firstName = _firstName;
        this.fullName = _fullName;
        this.email = _email;
        this.domain = _domain;
        this.majorComp = _majorComp;
        this.detailComp = _detailComp;
        this.value = _value;

    }

    getAnswer() {
        const parsedDate = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium', timeStyle: 'medium', timeZone: 'Europe/Paris' }).format(this.date)

        const answer: IAnswer = [this.tribe,this.id, this.lastName, this.firstName, this.fullName, this.email, this.domain, this.majorComp, this.detailComp, this.value, parsedDate]
       
        return answer
    };

}